<template>
    <div class="Show goods">
        <van-nav-bar
                title="产品名称"
                left-text=""
                left-arrow
                @click-left="$router.back(-1)"
        />
        <div class="cmain">
            <van-swipe class="goods-swipe" :autoplay="3000">
                <van-swipe-item v-for="thumb in productInfo.imageUrls" :key="thumb">
                    <img :src="thumb" >
                </van-swipe-item>
            </van-swipe>

            <van-cell-group>
                <van-cell>
                    <div class="goods-title">{{ productInfo.name }}</div>
                    <div class="goods-infos" v-if="productInfo.summary">{{ productInfo.summary }}</div>
                    <div class="goods-price">
                        {{ getPriceType(productInfo.priceType).symbol }}{{ productInfo.price }}
                        <span class="del">原价：{{ getPriceType(productInfo.priceType).symbol }}{{ productInfo.originalPrice }}</span>
                    </div>
                </van-cell>
            </van-cell-group>

            <van-cell-group class="goods-cell-group" v-if="false">
                <van-cell>
                    <div class="van-cell-text">
                        {{ productInfo.tags }}
                    </div>
                </van-cell>
            </van-cell-group>

            <van-cell-group class="goods-cell-group goods-cell-combo">
                <van-cell v-if="productInfo.weight && productInfo.weight > 0">
                    <div class="van-cell-text">产品重量：{{ productInfo.weight }}kg</div>
                </van-cell>
                <van-cell v-for="opt in productInfo.options">
                    <div class="van-cell-text">{{ opt.key }}：{{ opt.value }}</div>
                </van-cell>
            </van-cell-group>

            <van-cell-group class="goods-cell-group goods-cell-combo" v-if="productInfo.type === 1 && productInfo.packageInfos && productInfo.packageInfos.length>0">
                <van-cell title="套餐"></van-cell>
                <van-cell>
                    <dl class="goods-cell-select" v-for="item in productInfo.packageInfos" 
                        :class="{active: item.id == productInfo.id}"
                        @click="choiceCombo(item)"
                    >
                        <dt>{{ item.name }}</dt>
                        <dd>{{ getPriceType(item.priceType).symbol }}{{item.price}}</dd>
                        <div class="clearb"></div>
                    </dl>
                    <!--<dl class="goods-cell-select">
                        <dt>贝拉米3段 3罐套餐</dt>
                        <dd>$30.7</dd>
                        <div class="clearb"></div>
                    </dl>
                    <dl class="goods-cell-select active">
                        <dt>贝拉米3段 3罐套餐</dt>
                        <dd>$30.7</dd>
                        <div class="clearb"></div>
                    </dl>
                    <dl class="goods-cell-select">
                        <dt>贝拉米3段 3罐套餐美国伽力果美国伽</dt>
                        <dd>$30.7</dd>
                        <div class="clearb"></div>
                    </dl>-->
                </van-cell>
            </van-cell-group>
            <van-cell-group class="goods-cell-group goods-cell-combo" v-if="productInfo.type ===2 && productInfo.productInfos && productInfo.productInfos.length>0">
                <van-cell title="产品"></van-cell>
                <van-cell>
                    <dl class="goods-cell-select" v-for="item in productInfo.productInfos" 
                        :class="{active: item.id == productInfo.id}"
                        @click="choiceCombo(item)"
                    >
                        <dt>{{ item.name }}</dt>
                        <dd>{{ getPriceType(item.priceType).symbol }}{{item.price}}</dd>
                        <div class="clearb"></div>
                    </dl>
                </van-cell>
            </van-cell-group>

            <van-cell-group class="goods-cell-group goods-cell-combo" v-if="productInfo.type === 1 && productInfo.specs && productInfo.specs.length > 0">
                <van-cell title="规格"></van-cell>
                <van-cell>
                    <router-link 
                        class="goods-cell-color"
                        v-for="specsItem in productInfo.specs" 
                        :class="{ active: specsItem.productId == productInfo.id }"
                        :to="{ path: '/m/transaction/' + specsItem.productId }"
                    >
                        {{ specsItem.specsValue }}
                    </router-link>
                    <!--<span class="goods-cell-color">绿色</span>
                    <span class="goods-cell-color">玫瑰色</span>
                    <span class="goods-cell-color">卡普奇诺色</span>-->
                </van-cell>
            </van-cell-group>

            <van-cell-group v-if="productInfo.isActive" class="goods-cell-group goods-cell-steppers">
                <van-cell title="数量">
                     <span class="stock">(库存{{ productInfo.virtualStock }}件)</span>
                     <van-stepper :min="goods.min" :max="goods.max" integer input-width="80px" v-model="goods.count" />
                </van-cell>
            </van-cell-group>

            <van-cell-group class="goods-cell-group goods-cell-combo" v-if="productInfo.desc">
                <van-cell title="详情"></van-cell>
                <van-cell class="detail">
                    <span v-html="productInfo.desc"></span>
                </van-cell>
            </van-cell-group>

            <van-goods-action v-if="productInfo.isActive">
                <van-goods-action-big-btn style="flex: 1.3;" @click="addShopCart()">
                    加入购物车
                </van-goods-action-big-btn>
                <van-goods-action-big-btn primary :to="{ path: '/m/Oder', query: { id: productInfo.id } }">
                    立即购买
                </van-goods-action-big-btn>
            </van-goods-action>
            <van-goods-action v-if="!productInfo.isActive">
                <van-goods-action-big-btn style="background: #ccc; border-color: #ccc;">
                    商品已下架
                </van-goods-action-big-btn>
            </van-goods-action>
            <div style="height: 60px"></div>
        </div>
    </div>
</template>

<script>
    import shopCart from '@/js/mixins/shopCart.js'
    import {
        Tag,
        Col,
        Swipe,
        SwipeItem,
        GoodsAction,
        GoodsActionBigBtn,
        GoodsActionMiniBtn,
        Stepper,
        Card
    } from 'vant';
    export default {
        components: {
            [Tag.name]: Tag,
            [Col.name]: Col,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionBigBtn.name]: GoodsActionBigBtn,
            [GoodsActionMiniBtn.name]: GoodsActionMiniBtn,
            [Stepper.name]: Stepper,
            [Card.name]: Card
        },
        mixins: [shopCart],
        data() {
            return {
                num: 1,
                goods: {
                    count: 1,
                    min: 1,
                    max: 100000
                },
                productInfo: {
                    id: 0,
                    options: []
                }
            }
        },
        mounted() {
            this.init()
        },
        watch: {
            '$route'() {
                this.init()
            }
        },
        methods: {
            init() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '加载中...'
                });
                this.productInfo.id = this.$route.params.id
                this.getProductInfo()
            },
            getProductInfo() {
                this.$axios.get(window.consts.apis.product + '?id=' + this.productInfo.id).then(res => { 
                    if (res.success) {
                        this.productInfo = res.result
                        
                        let options = []
                        for (let key in this.productInfo.options) {
                            options.push({ key: key, value: this.productInfo.options[key] })
                        }
                        this.productInfo.options = options
                    } else {
                        this.$toast.fail("数据加载失败!")
                    }
                    this.$toast.clear()
                }, error => {
                    var that = this
                    this.$toast.fail("数据加载失败!")
                    setTimeout(function(){
                        that.$toast.clear()
                    }, 500)
                })
            },
            onClickCart() {
                this.$router.push('/m/cart');
            },
            addShopCart() {
                if (!this.productInfo.name) {
                    return false //产品未加载成功
                }

                //数据库购物车
                let id = this.productInfo.id
                let num = this.goods.count
                let temp = { 
                    commodityId: id, 
                    quantity: num
                }
                let user = this.$store.state.user;
                if (user && user.id && user.id > 0) {
                    this._addToCart({ commodityId: id, quantity: num }).then(res=>{
                        if(res.success){
                            if (this.setShopCartLocalStorage(temp)) {
                                this.$toast.success("已加入购物车");
                            }
                        }else{
                            this.$toast.fail(res.error.message)
                        }
                    }).catch(e=>{
                        this.$toast.fail("出错啦，请稍候再试!")
                    });
                } else {
                    if (this.setShopCartLocalStorage(temp)) {
                        this.$toast.success("已加入购物车");
                    }
                }
                return ;
            },
            choiceCombo(item) {
                if(item.id !== this.productInfo.id){
                    this.$router.push({path:'/m/transaction/'+item.id});
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .goods {
        padding-bottom: 50px;
        &-swipe {
            img {
                width: 100%;
                display: block;
            }
        }
        &-title {
            padding-bottom: 6px;
            max-height:75px;
            overflow: hidden;
            border-bottom: 1px dashed #eee;
            font-size: 16px;
        }
        &-infos {
            margin-bottom: 10px;
            padding: 10px 0;
            color: #999;
            border-bottom: 1px dashed #eee;
        }
        &-price {
            padding-top: 6px;
            color: #f44;
            font-weight: bold;
            font-size: 18px;
            .del {
                text-decoration: line-through;
                font-size: 12px;
                color: #999;
                font-weight: normal;
                display: inline-block;
                margin-left: 5px;
            }
        }
        &-express {
            color: #999;
            font-size: 12px;
            padding: 5px 15px;
        }
        &-cell-group {
            margin: 8px 0;
            .van-cell__value {
                color: #999;
            }
        }
        &-cell-text {
            float: left;
        }
        &-cell-text.right {
            width: 84%;
        }
        &-tag {
            margin-left: 5px;
        }
        ::v-deep &-cell-combo .van-cell {
            padding: 5px 15px;
            img {
                width: 100%;
                margin:5px auto;
            }
        }
        &-cell-select {
            box-sizing: border-box;
            width: auto;
            height: auto;
            margin: 8px auto;
            border: 1px solid #999;
            padding: 8px;
            color: #333;
            dt {
                float: left;
                width: 75%
            }
            dd {
                float: right;
                text-align: right;
                width: 23%;
                margin: 0;
            }
        }
        &-cell-color {
            display: inline-block;
            margin:8px 8px 8px 0;
            padding: 4px 8px;
            box-sizing: border-box;
            border: 2px solid #999;
            color: #333;
        }
        &-cell-select.active, &-cell-color.active {
            border: 2px solid #f44;
            color: #f44;
        }
        ::v-deep &-cell-combo .van-card__title {
            font-size: 16px;
            line-height: 1.6;
            color: #1a1a1a;
            font-weight: bold;
        }
        ::v-deep &-cell-combo .van-card__desc {
            font-size: 14px;
        }
        &-cell-steppers {
            .van-cell__title {
                flex: 1;
            }
            .van-cell__value {
                flex: 4;
            }
            .van-stepper {
                float: right;
            }
            .stock {
                margin-left: 5px;
                float: right;
                height:30px; 
                line-height: 30px;
            }
        }
        ::v-deep .detail {
            p {
                margin: 0;
                padding: 0;
                img {
                    display: inherit;
                    margin: 0;
                }
            }
        }
    }
    .van-swipe {
        height:160px;
        background: #fff;
    }
    ::v-deep .van-swipe img {
        width:auto;
        height:100%;
        margin:0 auto;
    }
    .van-goods-action{
        bottom: 61px;
    }
</style>
